"use strict";
var isArray = Array.isArray;
module.exports = isArray;
//# sourceMappingURL=isArray.js.map